
import { useEffect, useState } from "react";
import Slider from "react-slick";
import { useTheme } from "./ThemeProvider";
const BrandSectionOne = () => {
  const [isMobile, setIsMobile] = useState(false);
    const { isDarkMode } = useTheme();
  const iconsList = [
    '/assets/images/icons/banner_logo_1.svg',
    '/assets/images/icons/banner_logo_2.svg',
    '/assets/images/icons/banner_logo_8.svg',
    '/assets/images/icons/banner_logo_9.svg',
    '/assets/images/icons/banner_logo_10.svg',
    '/assets/images/icons/banner_logo_11.svg',
    '/assets/images/icons/banner_logo_12.svg',
    '/assets/images/icons/banner_logo_13.svg',
    '/assets/images/icons/banner_logo_14.svg',
    '/assets/images/icons/banner_logo_15.svg',
    '/assets/images/icons/banner_logo_16.svg',
    '/assets/images/icons/banner_logo_17.svg',
    '/assets/images/icons/banner_logo_18.svg',
    '/assets/images/icons/banner_logo_19.svg',
    '/assets/images/icons/banner_logo_20.svg',
    '/assets/images/icons/banner_logo_21.svg',
    '/assets/images/icons/banner_logo_22.svg',
    '/assets/images/icons/banner_logo_23.svg',
    '/assets/images/icons/banner_logo_24.svg',
    '/assets/images/icons/banner_logo_25.svg',
    '/assets/images/icons/banner_logo_26.svg',
    '/assets/images/icons/banner_logo_27.svg',
    '/assets/images/icons/banner_logo_28.svg',
    '/assets/images/icons/banner_logo_29.svg',
    '/assets/images/icons/banner_logo_30.svg',
    '/assets/images/icons/banner_logo_31.svg',
    '/assets/images/icons/banner_logo_32.svg',
    '/assets/images/icons/banner_logo_33.svg',
    '/assets/images/icons/banner_logo_34.svg',
    '/assets/images/icons/banner_logo_35.svg',
    '/assets/images/icons/banner_logo_36.svg',
    '/assets/images/icons/banner_logo_37.svg',
    '/assets/images/icons/banner_logo_38.svg',
    '/assets/images/icons/banner_logo_39.svg',
    '/assets/images/icons/banner_logo_40.svg',
    '/assets/images/icons/banner_logo_41.svg',
    '/assets/images/icons/banner_logo_42.svg',
    '/assets/images/icons/banner_logo_43.svg',
    '/assets/images/icons/banner_logo_44.svg',
    '/assets/images/icons/banner_logo_45.svg',
    '/assets/images/icons/banner_logo_46.svg',
  ]

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 5,
    slidesToScroll: 1,
    initialSlide: 0,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };


  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  return (
    <div className="brand">
      <div className={isMobile ? "" : "container container-three"}>
        <div className="brand-slider">
          <Slider {...settings}>
            {
              iconsList.map((icon, index) => (
                <div className="brand-items d-flex align-items-center justify-content-center" key={index}>
                  <img
                    src={icon}
                    width={130}
                    height={130}
                    style={{
                      width: 130,
                      height: 130,
                      objectFit: 'contain',
                      flexShrink: 0,
                      border: isDarkMode ? '1px solid #C3C3C3' : '',
                      borderRadius: 16,
                    }}
                    alt=""
                  />
                </div>
              ))
            }
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default BrandSectionOne;
